import { ReactNode } from 'react'

import { tsOfficeFax, tsOfficePhone } from 'constants/misc'

/**
 * Header, footer and page frame shared by every public patient page, whether
 * it lives under `/landing/*` or at its own top-level path.
 */
const LandingLayout = ({ children }: { children: ReactNode }) => (
  <div className="landing">
    <header>
      <h1 />
      <ul>
        <li>
          <a
            href="https://www.testsmarter.net/idtf-diagnostic-testing-facility/"
            target="_blank"
            rel="noreferrer"
          >
            Our Company
          </a>
        </li>
        <li>
          <a
            href="https://www.testsmarter.net/idtf-diagnostic-testing-facility/contact"
            target="_blank"
            rel="noreferrer"
          >
            Contact Us
          </a>
        </li>
      </ul>
    </header>
    <div className="content">{children}</div>
    <footer>
      <p>301 NW Cole Terrace, Ste 101</p>
      <p>Lake City, Florida 32055</p>
      <p>Phone: {tsOfficePhone}</p>
      <p>Fax: {tsOfficeFax}</p>
    </footer>
  </div>
)

export default LandingLayout
